// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsletterForm__row{border-radius:.25rem;padding:0 .1875rem}.NewsletterForm__row>.btn{margin:.375rem .25rem}@media(min-width:480px){.NewsletterForm__row>.btn{margin:.1875rem .25rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
